import React from "react";
import Skeleton from "react-loading-skeleton";
import "./Events.css";

const EventsSkeleton = () => {
  return (
    <div className="events-page">
      {/* Page heading */}
      <p className="events-head">
        <Skeleton width={200} height={30} />
      </p>

      {/* Desktop Event Info */}
      <div style={{ display: "flex", marginBottom: "40px" }}>
        <div style={{ flex: 1, paddingRight: "20px" }}>
          <Skeleton width={250} height={30} style={{ marginBottom: 15 }} />
          <Skeleton width={180} height={20} style={{ marginBottom: 10 }} />
          <Skeleton count={3} height={15} style={{ marginBottom: 8 }} />
          <Skeleton width={160} height={40} borderRadius={20} />
        </div>
        <div style={{ flex: 1 }}>
          <Skeleton height={250} borderRadius={16} />
        </div>
      </div>

      {/* Mobile Events Skeleton */}
      <div>
        {[1, 2].map((i) => (
          <div key={i} style={{ marginBottom: "25px" }}>
            <Skeleton width={180} height={25} style={{ marginBottom: 10 }} />
            <Skeleton count={2} height={15} style={{ marginBottom: 10 }} />
            <Skeleton width={160} height={40} borderRadius={20} style={{ marginBottom: 10 }} />
            <Skeleton height={180} borderRadius={16} />
          </div>
        ))}
      </div>

      {/* Carousel Skeleton */}
      <div style={{ display: "flex", gap: "20px", marginTop: "30px" }}>
        {[1, 2, 3].map((i) => (
          <div key={i} style={{ width: 250 }}>
            <Skeleton height={150} borderRadius={16} style={{ marginBottom: 10 }} />
            <Skeleton width={100} height={20} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventsSkeleton;

